import React from 'react';

import ExplorerIcon from 'components/FileViewer/ExplorerIcon';
import { ExplorerFolder, formatModified, pluralize } from 'helper/products/fileExplorer';

import './index.scss';

export default function QuickAccess({
  folders,
  onOpen,
}: {
  folders: ExplorerFolder[];
  onOpen: (path: string[]) => void;
}) {
  if (!folders.length) {
    return (
      <p className="file-explorer-quick-hint">
        <ExplorerIcon name="star" size={14} />
        Fixe as pastas que você mais usa com a estrela — elas aparecem aqui, no acesso rápido.
      </p>
    );
  }

  return (
    <section className="file-explorer-quick" aria-label="Acesso rápido">
      <h2 className="file-explorer-section-title">Acesso rápido</h2>
      <div className="file-explorer-quick-grid">
        {folders.map((folder) => {
          const parent = folder.path.slice(0, -1);
          return (
            <button
              key={folder.key}
              type="button"
              className="file-explorer-quick-card"
              onClick={() => onOpen(folder.path)}
            >
              <span className="file-explorer-quick-icon" aria-hidden="true">
                <ExplorerIcon name="folder" size={18} />
              </span>
              <span className="file-explorer-quick-text">
                <span className="file-explorer-quick-name">{folder.name}</span>
                <span className="file-explorer-quick-meta">
                  {parent.length ? `${parent.join(' / ')} · ` : ''}
                  {pluralize(folder.fileCount, 'arquivo', 'arquivos')}
                  {folder.latestModified !== null && ` · ${formatModified(folder.latestModified, false)}`}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
